import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MoneyInput } from "@/components/ui/money-input";
import { PriceWithAdjustment } from "@/components/proposals/PriceWithAdjustment";

interface HandlingFeeStepProps {
  data: any;
  onChange: (data: any) => void;
  readOnly?: boolean;
}

const HandlingFeeStep = ({ data, onChange, readOnly }: HandlingFeeStepProps) => {
  const isReadOnly = !!readOnly;
  const handlingFee = data.handlingFee?.[0] || {};

  const handleChange = (field: string, value: any) => {
    if (isReadOnly) return;
    const updatedFee = { ...handlingFee, [field]: value };
    onChange({ 
      ...data, 
      handlingFee: [updatedFee]
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Handling Fee</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Configure the handling fee for this proposal
        </p>
      </div>

      <div className="grid gap-5 p-6 border rounded-lg bg-card shadow-sm">
        <div className="space-y-2">
          <Label htmlFor="fee_title" className="text-sm font-medium">Fee Title</Label>
          <Input
            id="fee_title"
            value={handlingFee.fee_title || ""}
            onChange={(e) => handleChange('fee_title', e.target.value)}
            placeholder="Enter fee title"
            disabled={isReadOnly}
          />
        </div>

        <div className="space-y-2 border-t pt-5">
          <Label htmlFor="fee_price" className="text-sm font-medium">Fee Price</Label>
          <MoneyInput
            id="fee_price"
            value={handlingFee.fee_price}
            onChange={(value) => {
              handleChange('fee_price', value ? parseFloat(value) : null);
            }}
            className="w-[140px]"
            disabled={isReadOnly}
          />
        </div>

        <div className="space-y-2 border-t pt-5">
          <Label htmlFor="fee_description" className="text-sm font-medium">Fee Description</Label>
          <Textarea
            id="fee_description"
            value={handlingFee.fee_description || ""}
            onChange={(e) => handleChange('fee_description', e.target.value)}
            placeholder="Enter fee description..."
            className="min-h-[100px]"
            disabled={isReadOnly}
          />
        </div>

        <div className="flex justify-end border-t pt-3">
          <div className="text-right">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Item total</p>
            <PriceWithAdjustment
              baseAmount={Number(handlingFee.fee_price || 0)}
              proposalData={data}
              adjustable={false}
              size="md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandlingFeeStep;
